import { useInView } from "../../../hooks/useInView";

export default function StatsSection() {
  const { ref, inView } = useInView();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="bg-gray-50 border-t border-gray-200 border-b py-12 md:py-16 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-dot-grid-light pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-0">
          {/* Left */}
          <div
            className={`flex-1 pr-0 md:pr-12 anim-hidden ${inView ? "animate-fade-in-left" : ""}`}
          >
            <p className="font-condensed font-black text-gray-900 text-2xl md:text-3xl uppercase tracking-wide mb-2">
              PWA
            </p>
            <p className="text-gray-500 text-sm md:text-base">
              USA&apos;s Premier Wrestling Alliance &amp; Events Showcase
            </p>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-16 bg-gray-300" />
          <div className="block md:hidden w-16 h-px bg-gray-300" />

          {/* Right */}
          <div
            className={`flex-1 pl-0 md:pl-12 anim-hidden ${inView ? "animate-fade-in-right delay-150" : ""}`}
          >
            <p className="font-condensed font-black text-gray-900 text-2xl md:text-3xl uppercase tracking-wide mb-2">
              Scoop Slam Radio
            </p>
            <p className="text-gray-500 text-sm md:text-base">
              A Professional Wrestling &amp; Combat Sports Podcast
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
